import React from 'react';
import { PiBellDuotone, PiSignOutDuotone } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../app/providers/AuthContext';
import { useNotifications } from '../../app/providers/NotificationContext';
import { publicUserName } from '../../shared/utils/userDisplay';
import './Header.css';

/**
 * Header — верхняя панель приложения.
 * Показывается только на мобильных (< 640px), где sidebar скрыт.
 * На десктопе скрыт — там логотип и навигация в Sidebar.
 */
export default function Header() {
  const { user, logout } = useAuth();
  const { unreadCount } = useNotifications();
  const navigate = useNavigate();

  // ===================================================================================================================
  // = Implementation
  // ===================================================================================================================

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleNotifications = () => {
    navigate('/notifications');
  };

  const displayName = publicUserName(user);

  return (
    <header className="bm-header">
      {/* Логотип */}
      <div className="bm-header__logo">
        <span className="bm-header__logo-icon">⚡</span>
        <span className="bm-header__logo-text">BetMate</span>
      </div>

      {/* Правая часть */}
      <div className="bm-header__actions">
        <button
          className="bm-header__icon-btn bm-nav-icon-wrap"
          title="Уведомления"
          aria-label="Уведомления"
          onClick={handleNotifications}
        >
          <PiBellDuotone size={20} />
          {unreadCount > 0 && <span className="bm-notification-badge">{formatBadge(unreadCount)}</span>}
        </button>

        <div className="bm-header__user">
          <div className="bm-header__avatar" title={displayName}>
            {displayName.slice(0, 1).toUpperCase()}
          </div>
        </div>

        <button
          className="bm-header__icon-btn bm-header__icon-btn--danger"
          onClick={handleLogout}
          title="Выйти"
          aria-label="Выйти"
        >
          <PiSignOutDuotone size={20} />
        </button>
      </div>
    </header>
  );
}

function formatBadge(count) {
  return count > 99 ? '99+' : count;
}
